import React, { FC, useEffect, useState } from 'react';
import { Box } from '@material-ui/core';

import { StepWizardChildProps } from '../StepWizard';
import Step from './components/Step';
import Question from './components/Question';

import { withStyles } from '@material-ui/core/styles';
import { ToggleButton, ToggleButtonGroup } from '@material-ui/lab';
import color from 'color';

const StyledToggleButtonGroup = withStyles(theme => ({
  root: {
    width: '100%',
    borderRadius: 6,
  },
  grouped: {
    '&:not(:first-child)': {
      borderRadius: 'inherit',
    },
    '&:not(:last-child)': {
      borderRadius: 'inherit',
    },
  },
}))(ToggleButtonGroup);

const StyledToggleButton = withStyles(theme => ({
  root: {
    display: 'block',
    // maxWidth: 271,
    width: '100%',
    color: '#3E3E3E',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '20px',
    lineHeight: '24px',
    textTransform: 'none',
    border: '1px solid transparent',
    boxShadow: '0px 0px 30px rgba(209, 209, 209, 0.25)',
    backgroundColor: '#ffffff',
    borderRadius: 6,
    marginBottom: 22,
    height: 87,

    // [theme.breakpoints.up('sm')]: {
    //   borderRadius: 50,
    // },

    '& .title': {
      fontWeight: 'bold',
      fontSize: '24px',
      lineHeight: '29px',
      marginBottom: 5,
    },

    '& .description': {
      fontSize: '16px',
      lineHeight: '19px',
      color: '#919191',
    },

    '&:hover': {
      backgroundColor: color('#ffffff')
        .darken(0.1)
        .hex(),
    },

    '&$selected': {
      border: `1px solid ${theme.palette.primary.main}`,
      backgroundColor: '#ffffff',
      color: '#3E3E3E',
      // fontWeight: 600,
      '&:hover': {
        backgroundColor: color('#ffffff')
          .darken(0.1)
          .hex(),
      },
    },
  },
  sizeLarge: {
    // height: 60,
  },
  selected: {},
}))(ToggleButton);

interface Props extends Partial<StepWizardChildProps> {
  onUpdate?: (data: any, step: number) => void;
  onValidate?: (valid: boolean) => void;
}

const step = 4;

const StepCoverage: FC<Props> = ({ onUpdate, onValidate }) => {
  const [tier, setTier] = useState<'basic' | 'better' | 'best'>();

  useEffect(() => {
    if (typeof onValidate === 'function') {
      if (typeof tier !== 'undefined') {
        onValidate(true);
      } else {
        onValidate(false);
      }
    }
  }, [tier]);

  const handleChange = (event, value) => {
    if (!!value) {
      setTier(value);
      if (typeof onUpdate === 'function') {
        onUpdate({ tier: value }, step);
      }
    }
  };

  return (
    <Box>
      <Step num={step} />
      <Question
        label="Tell us what kind of Coverage you're looking for."
        style={{ maxWidth: 547 }}
      />
      <Box display="flex" justifyContent="center">
        <StyledToggleButtonGroup
          value={tier}
          exclusive
          onChange={handleChange}
          aria-label="basic, better, or best protection"
          size="large"
          style={{ display: 'block', backgroundColor: 'transparent' }}
        >
          <StyledToggleButton value="Basic" aria-label="Basic Protection">
            <div className="title">Basic Protection</div>
            <div className="description">
              Lower monthly payment for basic protection
            </div>
          </StyledToggleButton>
          <StyledToggleButton value="Better" aria-label="Better Protection">
            <div className="title">Better Protection</div>
            <div className="description">
              Standard monthly payment for the most common protection.
            </div>
          </StyledToggleButton>
          <StyledToggleButton value="Best" aria-label="Best Protection">
            <div className="title">Best Protection</div>
            <div className="description">
              Higher monthly payment for full protection.
            </div>
          </StyledToggleButton>
        </StyledToggleButtonGroup>
      </Box>
    </Box>
  );
};
export default StepCoverage;
